module.exports = __webpack_public_path__ + "img/icon_qrcode.651bc5ac.svg";